import React, { useContext, useEffect, useState } from 'react';
import classes from './PatientCard.module.css';
import ava from '../../../images/1.jpg';
import change from '../../../images/changer_icon.png';
import commentIcon from '../../../images/comment_icon.png';
import MyModal from '../MyModal/MyModal';
import PatientStat from '../PatientStat/PatientStat';
import WriteComment from '../WriteComment/WriteComment';
import { observer } from 'mobx-react-lite';
import { MainContext } from '../../..';
import { useWebSocketUpdations } from '../../../hooks/useWebSocketUpdations';
import { usePatient } from '../../../hooks/usePatient';

const PatientCard = observer(({ patientId, therapyId, bedId }) => {
    // Для модальных окон
    const [viewPatientStatsVisible, setViewPatientStatsVisible] = useState(false);
    const [writeCommentVisible, setWriteCommentVisible] = useState(false);
    const [patient, setPatient] = useState();

    const [indicatorUpdate, setIndicatorUpdate] = useState({
        id: 0,
        patient: patientId, // ID пациента, для которого это обновление
        pulse: 0,
        respiratory_rate: 0,
        saturation: 0,
        oxygen_flow: 0,
        timestamp: Date.now(),
    });
    const [spo2Update, setSpo2Update] = useState({
        therapy_id: therapyId,
        patient_id: patientId,
        spO2_value: 0,
    });
    const { medicalStore } = useContext(MainContext);
    useEffect(() => {
        const therapy = medicalStore.therapies.find((t) => t.id === therapyId);
        setSpo2Update({
            therapy_id: therapy.id,
            patient_id: therapy.patient,
            spO2_value: therapy.spO2_value,
        });
    }, []);

    // Установка значений, получаемых по вебсокету
    useWebSocketUpdations(patientId, setIndicatorUpdate, setSpo2Update);

    // Установка пациента
    usePatient(patientId, setPatient);

    return (
        <>
            <div
                className={classes.patientCard}
                onClick={() => setViewPatientStatsVisible(true)}
                title="Просмотр пациента"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className={classes.bedId}>
                            <div className={classes.place_value}>{bedId}</div>
                            <div className={classes.indicator_place}>место</div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '50%',
                                marginLeft: '5px',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div className={classes.patientName}>ID пациента: {patientId}</div>
                            <div className={classes.patientName}>ID терапии: {therapyId}</div>
                            <div className={classes.patientName}>
                                Имя: {patient?.user?.full_name}
                            </div>
                            <div className={classes.patientAge}>
                                Год рождения: {patient?.birthdate}
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100%',
                            marginRight: 5,
                        }}
                    >
                        {/* <button
                            className={classes.nullBtn}
                            onClick={(e) => {
                                e.stopPropagation();
                                alert(`Изменить данные пациента`);
                            }}
                            title="Изменить данные"
                        >
                            <img src={change} style={{ height: '35px' }} />
                        </button> */}
                        <button
                            className={classes.nullBtn}
                            onClick={(e) => {
                                e.stopPropagation();
                                // alert(`Добавить комментарий к пациенту ${name}`);
                                setWriteCommentVisible(true);
                            }}
                            title="Добавить комментарий"
                        >
                            <img src={commentIcon} style={{ height: '35px' }} />
                        </button>
                    </div>
                </div>
                <div className={classes.indicatorsBar}>
                    <div className={classes.indicator}>
                        <div className={classes.indicator_value}>{indicatorUpdate?.pulse}</div>
                        <div className={classes.indicator_name}>Пульс</div>
                    </div>
                    <div className={classes.indicator}>
                        <div className={classes.indicator_value}>
                            {indicatorUpdate?.respiratory_rate}
                        </div>
                        <div className={classes.indicator_name}>чдд</div>
                    </div>
                    <div className={classes.indicator}>
                        <div className={classes.indicator_value}>
                            {indicatorUpdate?.saturation}%
                        </div>
                        <div style={{ fontSize: 14, marginBlock: 5 }}>
                            Цель: {spo2Update?.spO2_value}%
                        </div>
                        <div className={classes.indicator_name}>SpO2</div>
                    </div>
                    <div className={classes.indicator}>
                        <div className={classes.indicator_value}>
                            {indicatorUpdate?.oxygen_flow}
                        </div>
                        <div className={classes.indicator_name}>л/мин</div>
                    </div>
                </div>
            </div>
            <MyModal visible={viewPatientStatsVisible} setVisible={setViewPatientStatsVisible}>
                <PatientStat
                    patientId={patientId}
                    therapyId={therapyId}
                    bedId={bedId}
                    setViewPatientStatsVisible={setViewPatientStatsVisible}
                />
            </MyModal>
            <MyModal visible={writeCommentVisible} setVisible={setWriteCommentVisible}>
                <WriteComment
                    therapyId={therapyId}
                    setWriteCommentVisible={setWriteCommentVisible}
                />
            </MyModal>
        </>
    );
});

export default PatientCard;

